export const sapPersonKeys = {
  all: ["sapPerson"] as const,
  find: (personId: string) => [...sapPersonKeys.all, personId] as const,
  org: (orgId: string) => [...sapPersonKeys.all, orgId] as const,
};
